const filterListModal = {
  text: 'FILTROS',
  clear: 'borrar todos los filtros'
};

export default filterListModal;
